import React, {useState} from "react";
import {Modal, Table} from "antd";
import {useStore} from "../../../../hooks/useStore";

const CustomerApproveDeliveryModal = ({
    orderDetails,
    totalOrdersPrice,
    payload,
    fromCustomerTheme,
    history,
    visible,
    onCancel,
    setShowCreditWarningModal = () => {},
    setCreditWarningMessage = () => {},
    onApprove
}) => {
    const stores = useStore();
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleOk = async () => {
        setConfirmLoading(true);
        try {
            if (onApprove) {
                await onApprove();
                return;
            }

            const response = await stores.apiRequestStore.createDelivery({
                ...payload,
                isFromCustomerTheme: fromCustomerTheme
            });

            if (response?.status === 200) {
                if (fromCustomerTheme) {
                    history.push("/musteri/siparislerim?orderType=current");
                } else {
                    history.push("/orders?orderType=current");
                }
            } else if (response?.status !== 200 && fromCustomerTheme) {
                setCreditWarningMessage(response?.data?.message || "Bir hata oluştu");
                setShowCreditWarningModal(true);
            }
        } finally {
            setConfirmLoading(false);
        }
    };

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            title={
                fromCustomerTheme
                    ? "Siparişinizi Onaylıyor Musunuz?"
                    : "Sipariş Gönderimini Onaylıyor Musunuz?"
            }
            className={fromCustomerTheme ? "customer-approve-delivery-modal" : ""}
            width={800}
            okButtonProps={
                fromCustomerTheme
                    ? {
                          style: {
                              backgroundColor: "#aef001",
                              border: "#000000",
                              color: "#000000"
                          }
                      }
                    : {}
            }
            okText={fromCustomerTheme ? "Onayla" : "Evet"}
            cancelText={fromCustomerTheme ? "İptal" : "Hayır"}
        >
            <p
                style={{
                    fontSize: "16px",
                    color: "#666",
                    marginBottom: "20px",
                    fontWeight: "500"
                }}
            >
                {fromCustomerTheme
                    ? "Siparişinize ait ücret bilgileri aşağıdaki gibidir."
                    : `Oluşturmakta olduğunuz${
                          orderDetails.length > 1 ? ` ${orderDetails.length} siparişe` : ` siparişe`
                      } ait ücret bilgileri aşağıdaki gibidir.`}
            </p>
            <Table
                dataSource={orderDetails}
                pagination={false}
                rowKey={"orderNumber"}
                summary={_ => (
                    <>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={5}>
                                <b style={{fontSize: "18px", verticalAlign: "middle"}}>
                                    Toplam Ücret{" "}
                                    <i style={{fontSize: "12px", fontWeight: "normal"}}>
                                        (KDV dahildir)
                                    </i>{" "}
                                    :
                                </b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                                <b style={{fontSize: "18px"}}>{totalOrdersPrice.toFixed(2)} ₺</b>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </>
                )}
            >
                <Table.Column title="Sipariş Numarası" dataIndex="orderNumber" />
                <Table.Column
                    title="Mesafe"
                    dataIndex="distance"
                    render={distance => `${Number(distance).toFixed(2)} km`}
                />
                <Table.Column
                    title="Ekstra Mesafe"
                    dataIndex="extraDistance"
                    render={extraDistance => `${Number(extraDistance).toFixed(2)} km`}
                />
                <Table.Column
                    title="Mesafe Ücreti"
                    dataIndex="distancePrice"
                    render={distancePrice => `${Number(distancePrice).toFixed(2)} ₺`}
                />
                <Table.Column
                    title="Paket Ücreti"
                    dataIndex="packagePrice"
                    render={packagePrice => `${Number(packagePrice).toFixed(2)} ₺`}
                />
                <Table.Column
                    title="Toplam"
                    dataIndex="totalPrice"
                    render={totalPrice => `${Number(totalPrice).toFixed(2)} ₺`}
                />
            </Table>
        </Modal>
    );
};

export default CustomerApproveDeliveryModal;
